import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { WithColor } from '@styles/colors';
import Svg from '@styles/icons/svg';
import i18n from 'i18n-js';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

interface SelectMachineForJobLineProps extends WithColor {
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

export const SelectMachineForJobLine: FC<SelectMachineForJobLineProps> = ({ C, font = initialFont, scale = initialScale }) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(9) }}>
      <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}>{i18n.t('Select')}</Text>
      <Svg icon="notSetupYet" color="Label/Light/Warning" width={scale(24)} height={scale(24)} />
    </View>
  );
};
